import React from "react";
import StatusChip from "./StatusChip";
import { BID_STATUS } from "../../utils/enums";

interface Props {
  status: string;
}

const BidStatusChip: React.FC<Props> = ({ status }) => {
  switch (status) {
    case BID_STATUS.WIN:
      return <StatusChip tone="success" icon="bi-trophy-fill" label="Win" />;
    case BID_STATUS.ACTIVE:
      return (
        <StatusChip tone="primary" icon="bi-hourglass-split" label="Active" />
      );
    case BID_STATUS.CLOSED:
      return (
        <StatusChip tone="danger" icon="bi-lock-fill" label="Closed" />
      );
    case BID_STATUS.PAID:
      return (
        <StatusChip tone="info" icon="bi-cash-stack" label="Paid" />
      );
    default:
      return null;
  }
};

export default BidStatusChip;
